export default {
  chatbotButton: {
    tooltip: {
      notes: 'Tooltip for the button which opens the chatbot window',
      message: 'Open conversation',
    },
  },
  disclaimer: {
    notes: 'Disclaimer text for the chatbot',
    message: 'The chatbot can make mistakes. Please verify all information.',
  },
  header: {
    viewingMismatching: {
      notes:
        'Prefix to indicate that the current conversation is for a specific equipment, which is NOT the currently selected equipment',
      message: 'Viewing',
    },
  },
  actions: {
    newConversation: {
      notes: 'Tooltip and/or title for button that starts a new conversation.',
      message: 'New conversation',
    },
    deleteConversation: {
      notes: 'Title for action delete conversation.',
      message: 'Delete conversation',
    },
    closeMenu: {
      notes: 'Tooltip and/or title for button that closes the (history) menu.',
      message: 'Close menu',
    },
    viewSelectedEquipment: {
      notes:
        'Tooltip and/or title for button that views a conversation for the currently selected equipment.',
      message: 'View selected equipment',
    },
    copyResponseId: {
      notes: 'Menu option for copying the messageId for a response message',
      message: 'Copy response ID',
    },
  },
  input: {
    placeholder: {
      notes: 'Placeholder for the user input field',
      message: 'Type a message...',
    },
  },
  messageBubble: {
    chatbotTitle: {
      notes: 'The name of the chatbot',
      message: 'SAM GPT',
    },
    userTitle: {
      notes: 'Message title referring to the user',
      message: 'Me',
    },
  },
  reference: {
    page: {
      notes: 'Page number title in reference image',
      message: 'Page',
    },
    openInNewTab: {
      notes: 'Button title for open pdf in new tab',
      message: 'Open in new tab',
    },
  },
  empty: {
    notASingleEquipment: {
      text: {
        notes:
          'Empty state message when zero or multiple equipment are selected',
        message: 'A single equipment has to be selected to use the chatbot',
      },
    },
    noMessages: {
      text: {
        notes: 'Empty state message when no messages exists yet',
        message: 'Write a question below to start talking to the chatbot',
      },
    },
    onlyAvailableInFleet: {
      text: {
        notes: 'Empty state message when the user has to navigate to fleet',
        message: 'Please navigate to Fleet to use the chatbot',
      },
      action: {
        notes: 'Label for a button that navigates the user to /fleet',
        message: 'Fleet',
      },
    },
    noPermit: {
      text: {
        notes: 'Empty state message when the user lacks the required permit',
        message:
          'Chatbot not available for the selected equipment. To use the chatbot, please select another equipment.',
      },
    },
  },
  history: {
    noHistory: {
      text: {
        notes: 'Empty state message when no history exists yet',
        message: 'No chat history yet. Start a conversation to see it here.',
      },
    },
  },
  rating: {
    menuItem: {
      notes: 'Menu item for rating a response',
      message: 'Rate response',
    },
    question: {
      notes: 'Question text asking for rating of a chatbot response',
      message: 'Was this response useful?',
    },
    values: {
      good: {
        notes: 'Option text for rating "good"',
        message: 'Yes',
      },
      neutral: {
        notes: 'Option text for rating "neutral"',
        message: 'Neutral',
      },
      bad: {
        notes: 'Option text for rating "bad"',
        message: 'No',
      },
    },
    feedbackSubmitted: {
      notes: 'Toast message for rating submitted',
      message: 'Feedback submitted!',
    },
    feedbackRemoved: {
      notes: 'Toast message for rating removed',
      message: 'Feedback removed',
    },
  },
  error: {
    technicalError: {
      notes: 'Toast error message',
      message: 'A technical error occured, please try again',
    },
    requestQuotaExceeded: {
      notes: '',
      message:
        "We're getting a bit too many requests right now. Please try again later.",
    },
  },
};
